import useSavedView from 'utils/hooks/useSavedViews/useSavedViews';

import {
  createSavedView,
  deleteSavedView,
  fetchSavedViews,
  sortSavedViews,
  updateSavedView,
} from './fetchSavedShipments';

const useSavedShipments = () =>
  useSavedView({
    createSavedView,
    deleteSavedView,
    fetchSavedViews,
    sortSavedViews,
    updateSavedView,
  });

export default useSavedShipments;
